import React, { Component } from "react"

// import api from '../services'
import utils from '../utils'
const { $, FE } = utils

export default class VoucherItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toUseUrl: ""
    }
    this.getCoupon = this.getCoupon.bind(this)
  }

  //领红包
  getCoupon(batchId) {
    if (this.state.toUseUrl) {
      return
    }
    let _this = this,
    cityId = this.props.cityInfo.cityId

    if (!FE.User.isLogin()) {
      FE.User.login()
      return false
    }

    // 点击统计(新)
    window.trackCustomEvent('auto_common_event',{
      'biz':'ec',
      'scene':0,
      'type':'click',
      'action':'mall_m_redpacket_redget_click',
      'ctime':new Date().getTime(),
      'area':0,
      'element':0,
      'pmark':0,
      'target':0,
      'ctype':0,
      'cid':0
    },{
      'ek1':0,
      'ek2':0
    })

    //领取红包
    $.ajax({
      url: "//coupon.mall.autohome.com.cn/coupon/market/grant",
      data: {
        batchId,
        cityId,
        userId: FE.User.getUserId(),
        loadId: window.pageLoadId || 0,
        pvAreaId: FE.Utils.readCookie("mpvareaid") || 0,
        visitsArea: FE.Utils.readCookie("ref") || 0
      },
      dataType: 'jsonp',
      success: function (data) {
        if (data.success || data.returncode === 2074009) {
          //领取成功或已领过，获取立即使用url
          let msg = data.success?"领取成功，感谢您的参与！":"您已领取过了",
          btnState = data.success?2:1
          $.ajax({
            url: "//coupon.mall.autohome.com.cn/coupon/market/nowuse/get",
            data: {
              batchId
            },
            dataType: 'jsonp',
            success: function (data) {
              if (data.success) {
                let symbol = data.result[0].nowUseUrl.indexOf('?')>-1?'&':'?'
                _this.setState({
                  toUseUrl: `https://m.mall.autohome.com.cn${data.result[0].nowUseUrl}${symbol}pvareaid=${_this.props.pvId[1]}`
                }, function(){
                  //(msg, toUseUrl, btnState)
                  // btnState：0错误提示（取消）、1已领过（立即使用）、2成功（立即使用+取消）
                  _this.props.show(msg, _this.state.toUseUrl,btnState)
                })
              } else {
                _this.props.show(data.message, "", 0)
              }
            },
            error: function (err) {
              _this.props.show(err.message, "", 0)
            }
          })
        } else {
          _this.props.show(data.message, "", 0)
        }
      },
      error: function (err) {
        _this.props.show(err.message, "", 0)
      }
    })
  }

  render() {
    let { coupon, pvId, cityInfo } = this.props,
    { toUseUrl } = this.state,
    iconStyle = coupon.pickCityIds.indexOf(cityInfo.cityId)>-1?'voucher-goods__icon':'voucher-goods__icon fn-hide',
    maxCoupon = {couponSum: 0},
    aText = "立即领取"
    
    if(coupon.couponL){
      coupon.couponL.map(ele => {
        if(ele.couponSum > maxCoupon.couponSum) maxCoupon = ele
      })
    }
    aText = maxCoupon.isZero?"已领完":toUseUrl?"立即使用":"立即领取"

    if(maxCoupon.couponSum === 0) {
      return null
    }

    return (
      <div className={maxCoupon.isZero?"voucher-item voucher-item-zero":"voucher-item"}>
        <a className='voucher-goods' href={FE.Utils.getHref(`https://m.mall.autohome.com.cn/detail/${coupon.itemId}-0-0.html?pvareaid=${pvId[0]}`)} target="_blank">
          <span className={iconStyle}>{cityInfo.cityName}提车</span>
          <div className='voucher-goods__box'>
            <img src={coupon.picUrl} alt=""/>
          </div>
          <div className='voucher-goods__info'>
            <p className='voucher-goods__info__name'>{coupon.name}</p>
            <p className='voucher-goods__info__ad'>{coupon.slogan}</p>
          </div>
        </a>
        <div className='voucher-info'>
          <p className='voucher-price'>
            ￥<span>{maxCoupon.couponSum}</span>
          </p>

          <a className={toUseUrl?"voucher-link hadgetredpack":"voucher-link"}
            href={toUseUrl ? FE.Utils.getHref(toUseUrl) : "javascript:;"}
            onClick={()=>this.getCoupon(maxCoupon.getId)}>
            {aText}
          </a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/VoucherItem.js